export default __webpack_public_path__ + "static/media/signInImage.127192f6.png";